import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail"]

  /**
   * Shows or hides the detail row that belongs to the clicked button.
   * The button carries the row id as an action param, the detail row repeats it
   * in data-row-id, so one controller can serve every row of a table.
   * @param {Event} event - Click event from the toggle button
   */
  toggle(event) {
    const button = event.currentTarget
    const detailRow = this.detailTargets.find((row) => row.dataset.rowId === String(event.params.id))

    if (!detailRow) return

    const expanded = button.getAttribute("aria-expanded") === "true"

    detailRow.hidden = expanded
    button.setAttribute("aria-expanded", String(!expanded))
  }
}
